import React from 'react';
import { Text as ShrikeText } from '@perch-labs/shrike';
import { Container, Row, RowChild, Text } from 'styles';
import { copyFor } from 'config';

const getCopy = copyFor('settings.moving.reviewNewHome');

interface Props {
  title: string;
  label: string;
  text?: string | null;
}

export const MovingAddress = ({ title, label, text }: Props) => {
  const color = title === getCopy('previousAddress') ? 'secondary' : 'primary';

  return (
    <Container width="100%">
      <ShrikeText
        tag="h2"
        textStyle="heading500"
        margin={{ bottom: '12px' }}
        color={color}
      >
        {title}
      </ShrikeText>
      <Row>
        <RowChild direction="column" alignItems="start" padding="0px">
          <ShrikeText
            tag="h2"
            textStyle="heading500"
            color={color}
            margin={{ top: '24px' }}
          >
            {label}
          </ShrikeText>
          <Text margin={{ top: '8px' }} color={color}>
            {text}
          </Text>
        </RowChild>
      </Row>
    </Container>
  );
};
